import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _set from 'lodash/set';
import { AppContext } from 'commons-ui';
import { FORM_FIELD_KEYS } from './formConfig';
import useService from '../utils/useService';
import { UserReferralCodeData } from '../utils/types';

const useUserDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert } = useContext(AppContext);
	const { requestUpdateUserReferralCode } = useService();

	const updateUserReferralCode = async (userReferralCodeData: UserReferralCodeData) => {
		requestUpdateUserReferralCode(userReferralCodeData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(
						res?.data?.externalMessage || res?.data?.error || 'Error occured while updating the users referral code',
						{
							type: 'error'
						}
					);
					setShowLoader(false);
					return;
				}
				showAlert('Referral code for user updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.externalMessage || err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = async (submitData: any) => {
		setShowLoader(true);
		const payload = {} as UserReferralCodeData;
		_set(payload, submitData[FORM_FIELD_KEYS.USER_DETAIL], (submitData[FORM_FIELD_KEYS.USER_ID] as string).trim());
		_set(payload, FORM_FIELD_KEYS.REFERRAL_CODE, (submitData[FORM_FIELD_KEYS.REFERRAL_CODE] as string).trim());
		await updateUserReferralCode(payload);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default useUserDetails;
